import React from 'react';
import { useTranslation } from 'react-i18next'; // For language handling


function KSACORS_FAQ() {
  const { t } = useTranslation(); // Hook for translation

  return (
    <div >
    {/* Hero Section */}
    <div className="hero-banner">
      <div className="hero-content" >
        <h1 style={{ color: 'black' }}>{t('FAQ_GEOID17_Title')}</h1>
        
      </div>
      
    </div>
    
    

    {/* Content Section */}
    <div className="hero-banner" style={{ backgroundColor: 'white' }}>
        <div className="hero-content">
          
          <p style={{ textAlign: 'justify' }}><b>{t('FAQ_KSACORS_Q1')}</b></p>
          <p style={{ textAlign: 'justify' }}>{t('FAQ_KSACORS_Q1_R1')}</p>
          <p style={{ textAlign: 'justify' }}><b>{t('FAQ_KSACORS_Q2')}</b></p>
          <p style={{ textAlign: 'justify' }}>{t('FAQ_KSACORS_Q2_R1')}</p>
          <p style={{ textAlign: 'justify' }}><b>{t('FAQ_KSACORS_Q3')}</b></p>
          <p style={{ textAlign: 'justify' }}>{t('FAQ_KSACORS_Q3_R1')}

          <ul>
          <li style={{ textAlign: 'justify' }}>{t('FAQ_KSACORS_Q3_R11')}</li>
          <li style={{ textAlign: 'justify' }}>{t('FAQ_KSACORS_Q3_R12')}
            <ul>
            <li>{t('FAQ_KSACORS_Q3_R121')}</li>
            <li>{t('FAQ_KSACORS_Q3_R122')}</li>
            </ul>            
          </li>
          <li style={{ textAlign: 'justify' }}>{t('FAQ_KSACORS_Q3_R13')}
          <ul>
            <li>{t('FAQ_KSACORS_Q3_R131')}</li>
            <li>{t('FAQ_KSACORS_Q3_R132')}</li>
            <li>{t('FAQ_KSACORS_Q3_R133')}</li>
            <li>{t('FAQ_KSACORS_Q3_R134')}</li>
            </ul> 
          </li>

            </ul></p>
          <p style={{ textAlign: 'justify' }}><b>{t('FAQ_KSACORS_Q4')}</b></p>
          <p style={{ textAlign: 'justify' }}>{t('FAQ_KSACORS_Q4_R1')}
          <ul>
            <li>{t('FAQ_KSACORS_Q4_R11')}</li>
            <li>{t('FAQ_KSACORS_Q4_R12')}</li>
            <li>{t('FAQ_KSACORS_Q4_R13')}</li>
            </ul> 


          </p>
          <p style={{ textAlign: 'justify' }}><b>{t('FAQ_KSACORS_Q5')}</b></p>
          <p style={{ textAlign: 'justify' }}>{t('FAQ_KSACORS_Q5_R1')}
          <ul>
          <li style={{ textAlign: 'justify' }}>{t('FAQ_KSACORS_Q5_R11')}</li>
          <li style={{ textAlign: 'justify' }}>{t('FAQ_KSACORS_Q5_R12')}</li>
          <li style={{ textAlign: 'justify' }}>{t('FAQ_KSACORS_Q5_R13')}</li>
          

        </ul></p>
          <p style={{ textAlign: 'justify' }}><b>{t('FAQ_KSACORS_Q6')}</b></p>
          <p style={{ textAlign: 'justify' }}>{t('FAQ_KSACORS_Q6_R1')}<ul>
          <li style={{ textAlign: 'justify' }}>{t('FAQ_KSACORS_Q6_R11')}</li>
          <li style={{ textAlign: 'justify' }}>{t('FAQ_KSACORS_Q6_R12')}</li>
          <li style={{ textAlign: 'justify' }}>{t('FAQ_KSACORS_Q6_R13')}</li>
          

        </ul></p>

          <p style={{ textAlign: 'justify' }}><b>{t('FAQ_KSACORS_Q7')}</b></p>
          <p style={{ textAlign: 'justify' }}>{t('FAQ_KSACORS_Q7_R1')}</p>
          
          <p style={{ textAlign: 'justify' }}><b>{t('FAQ_KSACORS_Q8')}</b></p>
          <p style={{ textAlign: 'justify' }}>{t('FAQ_KSACORS_Q8_R1')}<a  href="https://ksacors.geoportal.sa/RegisterAccount.aspx" target="_blank" rel="noopener noreferrer">
                  {t('ksa_cors_title')}
                </a> {t('FAQ_KSACORS_Q8_R2')}  </p>

          <p style={{ textAlign: 'justify' }}><b>{t('FAQ_KSACORS_Q9')}</b></p>
          <p style={{ textAlign: 'justify' }}>{t('FAQ_KSACORS_Q9_R1')}</p>
          <p style={{ textAlign: 'justify' }}><b>{t('FAQ_KSACORS_Q10')}</b></p>
          <p style={{ textAlign: 'justify' }}>{t('FAQ_KSACORS_Q10_R1')}</p>
          <p style={{ textAlign: 'justify' }}><b>{t('FAQ_KSACORS_Q11')}</b></p>
          <p style={{ textAlign: 'justify' }}>{t('FAQ_KSACORS_Q11_R1')}</p>
          <p style={{ textAlign: 'justify' }}><b>{t('FAQ_KSACORS_Q12')}</b></p>
          <p style={{ textAlign: 'justify' }}>{t('FAQ_KSACORS_Q12_R1')}</p>
          <p style={{ textAlign: 'justify' }}><b>{t('FAQ_KSACORS_Q13')}</b></p>
          <p style={{ textAlign: 'justify' }}>{t('FAQ_KSACORS_Q13_R1')} <a
              href={`mailto:${t('email_address')}`}
              target="_blank"
              rel="noopener noreferrer"
             
            > info@geosa.gov.sa</a></p>

          
         
      
        </div>
      </div>
      <div className="cards-space" style={{height:"40px"}}></div>
      
      
 
    
    </div>
);
}

export default KSACORS_FAQ;
